import { useFormatting } from './useFormatting';
import { useContractParamsGed } from './useContractParamsGed';
import { useCmgCalculationsGed } from './useCmgCalculationsGed';

/**
 * Orchestrator for the GED CMG simulator.
 */
export function useCmgSimulatorGed() {
  const formatting = useFormatting();
  const params = useContractParamsGed(formatting);
  const calculations = useCmgCalculationsGed(params);

  return {
    ...formatting,
    ...params,
    ...calculations,
  };
}
